import { SecurityOverviewBadgeEnum } from '@mews-commander/data-access';
import { SecurityTextKey as TextKey } from '../utils/SecurityTextKey';

export const securityOverviewContent = {
    [SecurityOverviewBadgeEnum.Low]: {
        variant: 'danger',
        textKey: TextKey.SecurityOverviewSecurityLevelLow,
        tooltipTextKey: TextKey.SecurityOverviewSecurityLevelLowTooltip,
        tipsTextKey: TextKey.SecurityOverviewTipsLevelLow,
    },
    [SecurityOverviewBadgeEnum.Medium]: {
        variant: 'warning',
        textKey: TextKey.SecurityOverviewSecurityLevelMedium,
        tooltipTextKey: TextKey.SecurityOverviewSecurityLevelMediumTooltip,
        tipsTextKey: TextKey.SecurityOverviewTipsLevelMedium,
    },
    [SecurityOverviewBadgeEnum.High]: {
        variant: 'success',
        textKey: TextKey.SecurityOverviewSecurityLevelHigh,
        tooltipTextKey: TextKey.SecurityOverviewSecurityLevelHighTooltip,
        tipsTextKey: TextKey.SecurityOverviewTipsLevelHigh,
    },
    [SecurityOverviewBadgeEnum.VeryHigh]: {
        variant: 'info',
        textKey: TextKey.SecurityOverviewSecurityLevelVeryHigh,
        tooltipTextKey: TextKey.SecurityOverviewSecurityLevelVeryHighTooltip,
    },
} as const;
